export const TYPE_OPTIONS = [
	{ id: 'PARTNER_COUPON_CASHLESS', label: 'PARTNER_COUPON_CASHLESS' },
	{ id: 'PARTNER_COUPON_CASH', label: 'PARTNER_COUPON_CASH' }
];

export const ALLOWED_PAYMENT_MODES_OPTIONS = [{ id: 'UPI', label: 'UPI' }];
